import { Box, IconButton, Image, MediaOverlay, Tooltip, Transition } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { Minimise } from '@wix/wix-ui-icons-common';
import React, { useEffect, useState } from 'react';
import { dataHooks } from '../../../../utils/datahooks';
import { resizeImageUrl } from '../../../../utils/resize-image-url';
import SvgEnlargedImage from './svgEnlargedImage';
const EnlargedImage = _ref => {
  let {
    enlargedImageHeight,
    enlargeImage,
    handleImageSize,
    enlargedImageSize,
    status,
    index,
    dataHook
  } = _ref;
  const {
    t
  } = useTranslation();
  const [urlToShow, setUrlToShow] = useState(enlargeImage.url);
  useEffect(() => {
    let isMounted = true;
    const resolveUrl = async () => {
      try {
        const resized = await resizeImageUrl(enlargeImage.url);
        if (isMounted) {
          setUrlToShow(resized);
        }
      } catch (err) {
        console.error('Failed to resize image', err);
        setUrlToShow(enlargeImage.url);
      }
    };
    resolveUrl();
    return () => {
      isMounted = false;
    };
  }, [enlargeImage.url]);
  return /*#__PURE__*/React.createElement(Transition, {
    enterAnimation: {
      fadeIn: {
        delay: 'short',
        duration: 'medium02',
        easing: 'enterEasing'
      },
      scaleUp: {
        delay: 'short',
        direction: 'topStart',
        duration: 'medium02',
        easing: 'enterEasing',
        scale: '100%'
      }
    },
    exitAnimation: {
      fadeOut: {
        duration: 'medium02',
        easing: 'exitEasing'
      },
      scaleDown: {
        direction: 'topStart',
        duration: 'medium02',
        easing: 'exitEasing',
        scale: '0%'
      }
    },
    show: enlargeImage.isImageEnlarged
  }, /*#__PURE__*/React.createElement(Box, {
    height: enlargedImageHeight,
    paddingBottom: "SP1",
    paddingTop: "5px",
    position: "relative",
    width: 226
  }, /*#__PURE__*/React.createElement(MediaOverlay, {
    borderRadius: "4px",
    hoverSkin: "none",
    media: /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SvgEnlargedImage, {
      height: enlargedImageHeight,
      width: 226
    }), /*#__PURE__*/React.createElement(Box, {
      align: "center",
      "align-items": "center",
      height: enlargedImageHeight,
      justifyItems: "center",
      position: "absolute",
      width: 226
    }, /*#__PURE__*/React.createElement(Image, {
      borderRadius: 0,
      dataHook: dataHooks.altImageRuleContentEnlargedImage(dataHook),
      fit: "contain",
      height: enlargedImageSize.height <= 84 ? enlargedImageSize.height : 150,
      position: "center",
      src: urlToShow,
      transparent: true,
      width: enlargedImageSize.width <= 84 ? enlargedImageSize.width : 226,
      onClick: event => handleImageSize(index, status, event)
    }))),
    onClick: () => handleImageSize(index, status)
  }, /*#__PURE__*/React.createElement(MediaOverlay.Content, {
    placement: "top-end",
    visible: "hover"
  }, enlargeImage.isImageEnlarged && /*#__PURE__*/React.createElement(Tooltip, {
    content: t('accessibility-wizard.alt-text.minimize-image-icon-button.tooltip'),
    placement: "top",
    size: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingBottom: "2px",
    paddingTop: "2px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    priority: "secondary",
    size: "small",
    onClick: event => {
      handleImageSize(index, status, event);
    }
  }, /*#__PURE__*/React.createElement(Minimise, null))))))));
};
export default EnlargedImage;
//# sourceMappingURL=enlargedImage.js.map